// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + chunkId + "." + "ec9fe77e329f76823000027ad70f2e89" + ".js";
};